import { useEffect, useState } from 'react'
import { School } from '../models'

const fetchedDistricts = []

const useAllSchools = (districtId) => {
  const [schools, setSchools] = useState([])
  const [isLoaded, setIsLoaded] = useState(false)

  const filters = { districtId: districtId || undefined }

  useEffect(() => {
    if (fetchedDistricts.includes(districtId)) return

    School
      .per(100)
      .where({ ...filters })
      .order('name')
      .all()
      .then((res) => {
        setSchools((prev) => ([...prev, ...res.data]))
        setIsLoaded(true)
        fetchedDistricts.push(districtId)
      })
  }, [districtId])

  return [schools, isLoaded]
}

export default useAllSchools
